import { component } from 'picoapp'
import $ from '../lib/quantdom'
import { get } from '../lib/ajax'


export default component((node) => {
  const url = $(node).attr('data-url')
  const productId = $(node).attr('data-product-id')
  const isDynamic = $(node).attr('data-is-dynamic')

  if (isDynamic === 'true') {
    get(url+`&product_id=${productId}`).then((res) => {
      const parser = new DOMParser()
      const doc = parser.parseFromString(res, 'text/html')
      const html = doc.querySelector('.js-recommended-products').innerHTML
      $(node).html(html)
    })
  } 
})
